export default __webpack_public_path__ + "static/media/agents-zoom.bd61560a.webp";